module.exports = __webpack_public_path__ + "static/media/playlist.9b2a306c.svg";